import React from "react";
import "./styles.scss";

const Index = ({ data, onClick }) => {
  let inputElement = null;

  inputElement = (
    <>
      <div
        className={`tab-button-wrapper ${data.lan} ${data.type} ${data.size} ${
          data.isActive ? "active-me " : "default"
        }`}
        onClick={onClick}
      >
        <div className={`tbw__name ${data.lan}`}>{data.tabName}</div>
      </div>
    </>
  );

  return <>{inputElement}</>;
};
Index.propTypes = {};

Index.defaultProps = {};
export default Index;
